import { render } from "./Requirements.vue?vue&type=template&id=68b0b18e&scoped=true"
import script from "./Requirements.vue?vue&type=script&lang=js"
export * from "./Requirements.vue?vue&type=script&lang=js"

import "@/Common/Styles/poolRequirements.scss?vue&type=style&index=0&id=68b0b18e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b0b18e"]])

export default __exports__